// extracted by mini-css-extract-plugin
export var content = "TextGrid-module--content--91fc4";
export var copyBlocks = "TextGrid-module--copyBlocks--651aa";
export var rows2 = "TextGrid-module--rows2--e69e1";
export var rows3 = "TextGrid-module--rows3--3a950";
export var rows4 = "TextGrid-module--rows4--438ba";
export var textGrid = "TextGrid-module--textGrid--a8349";